import styled from 'styled-components';

export const Container = styled.div`
  min-width: 720px;
  gap: 10px;
  height: 85vh;
  padding: 1rem;
  overflow: auto;
`;

export const Wrapper = styled.div`
  margin-bottom: 0.8rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #c2cfd6;
  width: 100%;
`;

export const Header = styled.div`
  padding: 0.7rem 1.3rem;
  background-color: transparent;
  border-bottom: 1px solid #c2cfd6;

  strong {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 2rem;
  margin-bottom: 40px;
`;
